import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri:
    (import.meta as any).env.VITE_API_URL ||
    "https://api.stylistgpt.ai/graphql",
  // Increase timeout for long-running requests (5 minutes)
  fetchOptions: {
    timeout: 300000, // 5 minutes in milliseconds
  },
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});

export default client;
